import { MenuIdAddons } from '@jira/navigation-apps__constants/src/MenuIdAddons.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { getNavigationForgeGlobalPageResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { forgeGlobalRoute } from '@jira/router-routes__forge-routes/src/forgeGlobalRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ForgeGlobalPage, { LazyForgeGlobalPage } from './ui/global/index.tsx';

export const forgeGlobalRouteEntry: Route = createEntry(forgeGlobalRoute, () => ({
	// eslint-disable-next-line no-restricted-syntax
	component: ForgeGlobalPage,
	layout: createLayout(),

	navigation: {
		menuId: MenuIdAddons,
	},

	resources: [...getNavigationResources(), ...getNavigationForgeGlobalPageResources()],
	forPaint: [LazyAtlassianNavigation, LazyForgeGlobalPage],
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
